import DrawerServiceProfileOwners from './DrawerServiceProfileOwners';

export default DrawerServiceProfileOwners;
